import './Modal.css';
import { Box, IconButton } from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ModalProps {
  title?: string;
  onClose: () => void;
}

const ModalHeader = ({ title, onClose }: ModalProps): JSX.Element => {
  return (
    <Box className="modal-header">
      <Box className="title">{title}</Box>
      <IconButton onClick={onClose}>
        <FontAwesomeIcon icon={faTimes} size="1x" />
      </IconButton>
    </Box>
  );
};

export default ModalHeader;
